/* Inkida product cards: swatch hover swaps the card image */
(function(){
  function card(el){return el.closest ? el.closest('.ik-card') : null;}
  function img(c){return c ? c.querySelector('.ik-img-1') : null;}
  function enter(e){
    var a=e.target.closest && e.target.closest('.ik-sw-a'); if(!a) return;
    var c=card(a), i=img(c), src=a.getAttribute('data-img'); if(!c||!i) return;
    if(!i.dataset.ikSrc){i.dataset.ikSrc=i.getAttribute('src')||'';i.dataset.ikSrcset=i.getAttribute('srcset')||'';}
    c.querySelectorAll('.ik-sw-a.is-active').forEach(function(x){x.classList.remove('is-active');});
    a.classList.add('is-active');
    if(src){i.removeAttribute('srcset');i.setAttribute('src',src);c.classList.add('is-swatching');}
  }
  function leave(e){
    var ul=e.target.closest && e.target.closest('.ik-sw'); if(!ul) return;
    if(e.relatedTarget && ul.contains(e.relatedTarget)) return;
    var c=card(ul), i=img(c); if(!c||!i||!i.dataset.ikSrc) return;
    i.setAttribute('src',i.dataset.ikSrc); if(i.dataset.ikSrcset) i.setAttribute('srcset',i.dataset.ikSrcset);
    c.classList.remove('is-swatching');
    c.querySelectorAll('.ik-sw-a.is-active').forEach(function(x){x.classList.remove('is-active');});
  }
  document.addEventListener('mouseover',enter);
  document.addEventListener('focusin',enter);
  document.addEventListener('mouseout',leave);
  document.addEventListener('focusout',leave);
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('.ik-sw-a');if(a){e.stopPropagation();}},true);
})();
/* Preview-only helper: ?ik_demo=hover shows the hover state on the first cards */
(function(){
  if(!/[?&]ik_demo=hover/.test(location.search)) return;
  function go(){var cs=document.querySelectorAll('.ik-card');for(var i=0;i<cs.length&&i<2;i++){cs[i].classList.add('ik-demo-hover');}}
  if(document.readyState!=='loading') go(); else document.addEventListener('DOMContentLoaded',go);
})();
